import { Intervention } from '@/app/components/action-plan/types';
import { Badge, Box, Button, Flex, IconArrowDown, IconArrowRight, Text, useDisclosure } from '@cmpsr/components';
import ModalInterventionDetails from '../../../modals/details/modal-intervention-details';
import { formatDate } from '../utils/group-by-month';
import { formatRiskRound } from '@/utils';

type CompletedInterventionCardProps = {
  intervention: Intervention;
};

export default function CompletedInterventionCard({ intervention }: CompletedInterventionCardProps) {
  const { copyWhenCompleted, completedAt, overallRiskImpact, isNonQuantifiable } = intervention;
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Flex
      alignItems="flex-start"
      gap={5}
      position="relative"
      maxW={{ base: '100%', lg: '780px' }}
      p={{ base: 5, lg: 6 }}
      pr="8 !important"
      border="1px solid"
      borderColor="ui-element-divider"
      borderRadius="radii-3"
      _hover={{ bg: 'background-container-hover' }}
      _active={{ bg: 'background-container-pressed' }}
      _focus={{ boxShadow: 'none' }}
      cursor="pointer"
      onClick={onOpen}
    >
      <Flex alignItems="center">
        <Badge
          color="text-success"
          backgroundColor="alert-success-default"
          p="spacer-2"
          borderRadius="radii-3"
          w="max-content"
        >
          <IconArrowDown />
          {isNonQuantifiable ? null : (
            <Text color="text-success" variant="text-body-meta-bold">
              {formatRiskRound(overallRiskImpact)}
            </Text>
          )}
        </Badge>
      </Flex>
      <Flex direction="column" alignItems="flex-start" gap={1}>
        <Text variant="text-body-meta-regular">{formatDate(completedAt)}</Text>
        <Box>
          <Text variant="text-body-regular" display="inline" mr={1} color="text-primary">
            {copyWhenCompleted}.
          </Text>
          <Button variant="link-primary" size="s" borderBottom="1px solid" borderRadius={0} onClick={onOpen}>
            <Text variant="text-body-medium" lineHeight="1.1rem">
              See details
            </Text>
          </Button>
        </Box>
      </Flex>
      <IconArrowRight
        position="absolute"
        right="spacer-2"
        top="50%"
        transform="translateY(-50%)"
        color="text-primary"
      />
      <ModalInterventionDetails isOpen={isOpen} onClose={onClose} intervention={intervention} />
    </Flex>
  );
}
